import { Machine, assign } from "xstate";
import { stateValuesEqual } from "xstate/lib/State";

const listingType = {
  initial: "noError",
  states: {
    noError: {
      initial: "unset",
      on: {
        SUBMIT: [
          {
            cond: (context, event) =>
              !context.listingType || context.listingType.length === 0,
            target: "error.empty"
          }
        ]
      },
      states: {
        unset: {},
        buyNow: {},
        absolute: {},
        reserve: {}
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const buyNowPrice = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: {
          cond: (context, event) =>
            context.listingType === "buyNow" &&
            !(
              context.buyNowPrice ||
              (context.buyNowPrice && context.buyNowPrice.length === 0)
            ),
          target: "error.empty"
        }
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const reservePrice = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: {
          cond: (context, event) =>
            context.listingType === "reserveAuction" &&
            !(
              context.reservePrice ||
              (context.reservePrice && context.reservePrice.length === 0)
            ),
          target: "error.empty"
        }
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

export const getStep5 = (values: any) => {
  const defaultValues = {
    listingType: "",
    buyNowPrice: undefined,
    reservePrice: undefined
  };
  const config = {
    id: "step5",
    initial: "ready",
    context: {
      ...defaultValues,
      ...values
    },
    states: {
      ready: {
        type: "parallel",
        on: {
          INPUT_LISTING_TYPE: [
            {
              actions: assign((context: any, event: any) => {
                return { listingType: event.listingType };
              }),
              cond: (_: any, event: any) => event.listingType === "buyNow",
              target: [
                "ready.listingType.noError.buyNow",
                "ready.reservePrice.noError"
              ]
            },
            {
              actions: assign((context: any, event: any) => {
                return { listingType: event.listingType };
              }),
              cond: (_: any, event: any) =>
                event.listingType === "absoluteAuction",
              target: [
                "ready.listingType.noError.absolute",
                "ready.reservePrice.noError",
                "ready.buyNowPrice.noError"
              ]
            },
            {
              actions: assign((context: any, event: any) => {
                return { listingType: event.listingType };
              }),
              cond: (_: any, event: any) =>
                event.listingType === "reserveAuction",
              target: [
                "ready.listingType.noError.reserve",
                "ready.buyNowPrice.noError"
              ]
            }
          ],
          INPUT_RESERVE_PRICE: {
            actions: assign((context: any, event: any) => {
              return { reservePrice: event.reservePrice };
            }),
            target: "ready.reservePrice.noError"
          },
          INPUT_BUY_NOW_PRICE: {
            actions: assign((context: any, event: any) => {
              return { buyNowPrice: event.buyNowPrice };
            }),
            target: "ready.buyNowPrice.noError"
          },
          SUBMIT: {
            cond: (context, event, meta) => {
              if (
                meta.state.matches("ready.listingType.error") ||
                meta.state.matches("ready.buyNowPrice.error") ||
                meta.state.matches("ready.reservePrice.error")
              ) {
                return false;
              }

              return true;
            },
            target: "finished"
          }
        },
        states: {
          listingType: {
            ...listingType
          },
          reservePrice: {
            ...reservePrice
          },
          buyNowPrice: {
            ...buyNowPrice
          }
        }
      },
      error: {
        type: "parallel",
        listingType: {
          ...listingType
        },
        reservePrice: {
          ...reservePrice
        },
        buyNowPrice: {
          ...buyNowPrice
        }
      },

      noError: {},
      finished: {
        type: "final"
      }
    }
  };

  const step5 = Machine(config as any);
  return step5;
};
